import React from "react";
import { useSearchParams } from "react-router-dom";

import ListerWizard from "./ListerWizard";

// Standalone page for the listing flow — rendered outside the site Layout, so
// no navbar or footer. Just the navy panel and the existing wizard.
const ListYourStorageWizardPage = () => {
  const [searchParams] = useSearchParams();

  // Campaign attribution — carried into the lead payload
  const utmParams = {
    utm_source: searchParams.get("utm_source") || "",
    utm_medium: searchParams.get("utm_medium") || "",
    utm_campaign: searchParams.get("utm_campaign") || "",
  };

  return (
    <section className="py-5" style={{ backgroundColor: "#000034", minHeight: "100vh" }}>
      <div className="container">
        <h2 className="text-center text-white fw-bold mb-2">
          Let's get your space <span className="mineTextOrange">listed</span>
        </h2>
        <p className="text-center text-white-50 mb-5">
          Answer a few quick questions — do it yourself, or let us handle everything.
        </p>
        <ListerWizard utmParams={utmParams} />
      </div>
    </section>
  );
};

export default ListYourStorageWizardPage;
